import { Component } from 'react';
import { observer } from 'mobx-react';
import { getDataProps } from '../utils';
import ThemeStore from '../store';
import style from './style';

class ToggleButton extends Component
{
  static defaultProps = {
    enabled: true,
    checked: false,
    backgroundColor: null,
  }

  get backgroundColor()
  {
    return this.props.backgroundColor || ThemeStore.theme.toggleKnob;
  }

  get toggleStyle()
  {
    if(this.props.checked)
    {
      return {
        backgroundColor: 'rgba(66, 172, 89, 1)',
      };
    }
    else
    {
      return {
        backgroundColor: 'rgba(230,230, 230, 1)',
      };
    }
  }

  get circleStyle()
  {
    if(this.props.checked)
    {
      return {
        backgroundColor: "rgba(255,255,255,1)",
        border: 0,
      };
    }
    else
    {
      return {
        backgroundColor: "rgba(255,255,255, 1)",
        borderColor: 'rgba(0, 0, 0, 0.4)',
      };
    }
  }

  toggle = () => {
    const value = !this.props.checked;
    if(this.props.onChange)
      this.props.onChange(value);
  }

  componentDidUpdate(prevProps)
  {
    if(prevProps.checked!==this.props.checked)
      this.setState({checked: this.props.checked});
  }

  render() {
    const dataProps = getDataProps(this.props);
    const classList = [this.props.className];
    classList.push("toggle-button");
    if(this.props.checked)
      classList.push("checked");
    if(!this.props.enabled)
      classList.push("disabled");

    return (
      <div style={{...this.colors, ...this.props.style}} {...dataProps} className={classList.join(" ")} onClick={() => {this.toggle();}}>
        <div className="toggle" style={this.toggleStyle} data-tip-anchor>
          <div className="circle" style={this.circleStyle} />

          {this.props.isProcessing && (<div className="lines">
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>)}
        </div>

        <div className="label">{this.props.label}</div>

        <style jsx>{style}</style>
      </div>
    );
  }
}

export default observer(ToggleButton);